import React from 'react';

interface VrukshaEduLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const VrukshaEduLogo: React.FC<VrukshaEduLogoProps> = ({
  width = 100,
  height = 100,
  className = '',
}) => {
  return (
    <img
      src="/nammapreplogo.png"
      alt="NammaPrep"
      width={width}
      height={height}
      className={className}
      style={{ objectFit: 'cover', borderRadius: '50%' }}
    />
  );
};

export default VrukshaEduLogo;
